import LinkBranded from 'src/elements/links/2023_Q4/LinkBranded';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export interface ResourcesMegaMenuFeaturedWrapperProps {
  noBackground?: boolean;
}

export const ResourcesMegaMenuFeaturedWrapper = styled.div<ResourcesMegaMenuFeaturedWrapperProps>`
  margin: 0 auto;
  box-sizing: border-box;
  padding: 3.5rem 1rem;
  background: ${({ noBackground }) => (noBackground ? 'none' : palette.lightWheat)};
  border-left: ${({ noBackground }) => (noBackground ? 'none' : `solid 1px ${palette.wheat}`)};
  width: 100%;

  @media all and (max-width: ${layout.lg}) {
    padding: 1rem;
  }

  @media all and (max-width: ${layout.xs}) {
    padding: 1rem 0;
  }
`;

export interface ResourcesMegaMenuFeaturedContainerProps {
  isFullWidth?: boolean;
}

export const ResourcesMegaMenuFeaturedContainer = styled.div<ResourcesMegaMenuFeaturedContainerProps>`
  display: grid;
  width: 100%;
  row-gap: 1.5rem;
  max-width: ${({ isFullWidth }) => (isFullWidth ? '100%' : '582px')};
  margin: 0 auto;
`;

export const ResourcesMegaMenuFeaturedEntries = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;

  @media all and (max-width: ${layout.lg}) {
    gap: 1rem;
    grid-template-columns: 1fr 1fr;
  }

  @media all and (max-width: ${layout.subMd}) {
    gap: 1.5rem;
    grid-template-columns: 1fr;
  }
`;

export const ResourcesMegaMenuFeaturedEntry = styled.div`
  display: grid;
  row-gap: 1rem;

  .gatsby-image-wrapper {
    border-radius: 15px;
  }
`;

export const FeaturedEntryText = styled.div`
  display: grid;
  row-gap: 0.25rem;
  padding-top: 0.5rem;
`;

export const FeaturedEntryLink = styled(LinkBranded)`
  width: fit-content;
  justify-self: start;
  padding-left: 0;
  font-weight: 700;
  text-decoration: underline;
`;
